import { useMemo } from 'react';
import { useDayOfWeek } from '../useDayOfWeek';
import { useLocaleFirstDayOfWeekIndex } from '../useLocaleFirstDayOfWeekIndex';

/**
 * This hook will return the absolute offset/difference between the given dates day of the week and the locales first day of the week
 * @example locale=en-GB useFirstDayOfWeekOffset(Monday 25th March) => 0
 * @example locale=en-US useFirstDayOfWeekOffset(Monday 25th March) => 1
 * @example locale=en-GB useFirstDayOfWeekOffset(Tuesday 26th March) => 1
 * @example locale=en-US useFirstDayOfWeekOffset(Tuesday 26th March) => 2
 * @example locale=en-GB useFirstDayOfWeekOffset(Sunday 31th March) => 6
 * @example locale=en-US useFirstDayOfWeekOffset(Sunday 31th March) => 0
 */
export const useFirstDayOfWeekOffset = (date: Date) => {
    const localeFirstDayOfWeek = useLocaleFirstDayOfWeekIndex();
    const dayOfWeek = useDayOfWeek(date);

    const firstDayOffset = useMemo(() => {
        if (dayOfWeek === 0) {
            return (7 - localeFirstDayOfWeek) % 7;
        }
        return (dayOfWeek - localeFirstDayOfWeek) % 7;
    }, [dayOfWeek, localeFirstDayOfWeek]);

    return firstDayOffset;
};
